export const xmlToJson = (xml: Element | Node) => {
  let obj: unknown = {};

  if (xml.nodeType === 1) {
    if ((xml as Element).attributes.length > 0) {
      obj = { attributes: {} } as Element;
      for (let i = 0; i < (xml as Element).attributes.length; i += 1) {
        const attribute = (xml as Element).attributes.item(i);
        if (attribute) {
          // @ts-expect-error - Type issue was not resolved prior to TS5 upgrade.
          (obj as Element).attributes[attribute.nodeName] = attribute.nodeValue;
        }
      }
    }
  }

  if (xml.hasChildNodes()) {
    for (let i = 0; i < xml.childNodes.length; i++) {
      const item = xml.childNodes.item(i);
      const { nodeName } = item;
      // @ts-expect-error - Type issue was not resolved prior to TS5 upgrade.
      if (typeof (obj as ChildNode)[nodeName] === 'undefined') {
        // @ts-expect-error - Type issue was not resolved prior to TS5 upgrade.
        (obj as ChildNode)[nodeName] = xmlToJson(item);
      } else {
        // @ts-expect-error - Type issue was not resolved prior to TS5 upgrade.
        if (!Array.isArray((obj as ChildNode)[nodeName])) {
          // @ts-expect-error - Type issue was not resolved prior to TS5 upgrade.
          const currentNode = (obj as ChildNode)[nodeName];
          // @ts-expect-error - Type issue was not resolved prior to TS5 upgrade.
          (obj as ChildNode)[nodeName] = [];
          // @ts-expect-error - Type issue was not resolved prior to TS5 upgrade.
          (obj as ChildNode)[nodeName].push(currentNode);
        }
        // @ts-expect-error - Type issue was not resolved prior to TS5 upgrade.
        (obj as ChildNode)[nodeName].push(xmlToJson(item));
      }
    }
  }

  return obj;
};
